import { Step } from 'react-joyride';

export const steps = [
  {
    target: '#consumer-1',
    content: 'Here you can see the statistics of connection requests usage.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
  {
    target: '#consumer-2',
    content: 'Here you can see the statistics of universal requests usage.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
  {
    target: '#consumer-3',
    content: 'Here you can see the statistics of total requests usage.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
  {
    target: '#consumer-4',
    content: 'In this tab, you can see the current status of your integrations',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
  {
    target: '#consumer-5',
    content: 'Here you will see the connections you have set up.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
  {
    target: '#consumer-6',
    content: 'Here you will see the connections that are ready to be configured.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
  {
    target: '#consumer-7',
    content: 'Here you can see the latest consumer logs.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
  {
    target: '#consumer-8',
    content: 'Here you can see the actual credentials.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
  {
    target: '#consumer-9',
    content: 'Here you can see the consumer settings.',
    disableBeacon: true,
    hideCloseButton: true,
    showSkipButton: true,
    placement: 'top',
  },
] as Array<Step>;

export const locale = {
  last: 'Done',
};
